var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.409,
    height: 60.982,
    viewBox: "0 0 60.409 60.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14810",
    "data-name": "Group 14810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8079",
    "data-name": "Rectangle 8079",
    width: 60.409,
    height: 3.82,
    transform: "translate(0 28.486)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8080",
    "data-name": "Rectangle 8080",
    width: 3.819,
    height: 10.195,
    transform: "translate(32.267 13.976)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8081",
    "data-name": "Rectangle 8081",
    width: 3.819,
    height: 16.992,
    transform: "translate(44.352 7.179)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8082",
    "data-name": "Rectangle 8082",
    width: 3.819,
    height: 24.171,
    transform: "translate(56.421 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8083",
    "data-name": "Rectangle 8083",
    width: 3.819,
    height: 10.197,
    transform: "translate(24.324 36.811)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8084",
    "data-name": "Rectangle 8084",
    width: 3.819,
    height: 16.992,
    transform: "translate(12.238 36.811)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8085",
    "data-name": "Rectangle 8085",
    width: 3.819,
    height: 24.171,
    transform: "translate(0.172 36.811)",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.cd9eb5a96dc5c29c1fa0b5befd675c97.svg";
export { ForwardRef as ReactComponent };